<div class="reports-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <h2 class="page-title">
        <mat-icon>calendar_month</mat-icon>
        Labour Mobilization Plans
      </h2>
      <button class="btn-primary-large" (click)="addNewPlan()">
        <mat-icon>add</mat-icon>
        <span>Add New Plan</span>
      </button>
    </div>
  </div>

  <!-- Filters Card -->
  <div class="filter-card">
    <div class="filter-grid">
      <div class="filter-item">
        <mat-icon>search</mat-icon>
        <input type="text" class="filter-input" placeholder="Search plans..." 
               [(ngModel)]="searchKeyword" (keyup.enter)="applyFilter()" />
      </div>
      
      <div class="filter-item">
        <mat-icon>business</mat-icon>
        <select class="filter-select" [(ngModel)]="selectedProject" (change)="onFilterChange()">
          <option value="">All Projects</option>
          <option *ngFor="let project of projects" [value]="project.id">
            {{ project.project_name }}
          </option>
        </select>
      </div>
      
      <div class="filter-item">
        <mat-icon>calendar_today</mat-icon>
        <input type="date" class="filter-input" [(ngModel)]="startDate" 
               (change)="onFilterChange()" placeholder="Start Date" />
      </div>
      
      <div class="filter-item">
        <mat-icon>event</mat-icon>
        <input type="date" class="filter-input" [(ngModel)]="endDate" 
               (change)="onFilterChange()" placeholder="End Date" />
      </div>
      
      <button class="btn-filter" (click)="applyFilter()">
        <mat-icon>filter_list</mat-icon>
        <span>Apply</span>
      </button>
    </div>
  </div>

  <!-- Plans Table -->
  <div class="table-card">
    <div class="table-responsive-modern">
      <table mat-table [dataSource]="dataSource" matSort class="modern-table">
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="cell-center">
            {{ (pagination.current_page - 1) * pagination.items_per_page + i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="plan_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let element">
            <span class="date-badge">{{ formatDate(element.plan_date) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="project_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Project</th>
          <td mat-cell *matCellDef="let element" class="project-cell">
            <strong>{{ element.project_name || element.project_identifier }}</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="carpenders">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Carpenters</th>
          <td mat-cell *matCellDef="let element" class="cell-center">{{ element.carpenders || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="rein_fitters">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Rein. Fitters</th>
          <td mat-cell *matCellDef="let element" class="cell-center">{{ element.rein_fitters || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="masons">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Masons</th>
          <td mat-cell *matCellDef="let element" class="cell-center">{{ element.masons || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="total_available">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Total Available</th>
          <td mat-cell *matCellDef="let element" class="cell-center">
            <span class="total-badge">{{ element.total_available || 0 }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="expected_total_strength">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Expected</th>
          <td mat-cell *matCellDef="let element" class="cell-center">{{ element.expected_total_strength || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="shortage_against_committed">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Shortage</th>
          <td mat-cell *matCellDef="let element" 
              [class.text-danger]="element.shortage_against_committed < 0"
              [class.text-success]="element.shortage_against_committed >= 0"
              class="cell-center">
            {{ element.shortage_against_committed || 0 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="net_increase">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Net Increase</th>
          <td mat-cell *matCellDef="let element" class="cell-center">
            <span class="increase-badge">{{ element.net_increase || 0 }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Actions</th>
          <td mat-cell *matCellDef="let element" class="cell-center">
            <div class="action-group">
              <button mat-icon-button class="btn-action-view" (click)="viewPlan(element)" matTooltip="View">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button class="btn-action-edit" (click)="editPlan(element)" matTooltip="Edit">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="btn-action-delete" (click)="deletePlan(element)" matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="pagination.total_items"
      [pageSize]="pagination.items_per_page"
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      class="modern-paginator">
    </mat-paginator>

    <div *ngIf="loading" class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading plans...</p>
    </div>

    <div *ngIf="!loading && dataSource.data.length === 0" class="empty-state">
      <mat-icon>event_note</mat-icon>
      <h3>No Plans Found</h3>
      <p>Start by creating a new mobilization plan</p>
      <button class="btn-primary" (click)="addNewPlan()">
        <mat-icon>add</mat-icon>
        Create First Plan
      </button>
    </div>
  </div>
</div>
